/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

/*
* Display metadata popup window
*/
import React, { Component } from 'react';
import { TEXT_TYPES } from "../../../constants/APP_CONSTANTS";
import FileUploadDisplayComponent from '../../widgets/FileUploadDisplay/FileUploadDisplayComponent';
import MetadataUploadSelectComponent from "./MetadataUploadSelectComponent";
import AxiosClient from '../../../_helpers/http.helper';
import config from "../../../config";
import urlHelper from '../../../_helpers/url.format.helper';
import ModalDialog from "../../widgets/ModalDialog/ModalDialog";
import { Redirect } from 'react-router';

export default class UploadMetadataComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            file: "",
            formData: "",
            showPopup: false,
            statusModal: false,
            toViewLogs: false,
            percentage: 0,
            batchId: "",
            showBatchCompletePopup: false,
            batchStatus: "",
            failedMsg: "",
            showBatchStatus: "",
            disableImport: true,
            dropdown_selected: [
                { label: 'Content Type', value: 'Select Content Type'},
                { label: 'Source', value: 'Pearson' },
                { label: 'Sub Type', value: 'CSG' },
                { label: 'Unscrubbed', value: 'false' },
            ],
            enableImport: this.enableImport.bind(this),
            disableImportAction: this.disableImportAction.bind(this)     
        };

        this.showPopup = this.showPopup.bind(this);
        this.changeDropdownSelected = this.changeDropdownSelected.bind(this);
    }

    popupFileWindow() {
        document.getElementById("fileLoader").click();
    }

    handleChange(e) {
        if (e.target.files.length > 0) {
            this.setState({ showBatchStatus: "New" });
            this.setState({ failedMsg: "" });
            this.setState({ file: e.target.files[0].name });
            const formData = new FormData();
            formData.append('file', e.target.files[0]);
            this.setState({ formData: formData });
            this.setState({ disableImport: false });
        }
        if(this.state.dropdown_selected[0].value === 'Select Content Type'){
            this.setState({ disableImport: true });  
        }
    }

    showPopup() {
        this.setState({ showPopup: true });
        this.setState({ showBatchStatus: "" });
        this.setState({ failedMsg: "" });
    }

    closePopup() {
        this.setState({ showPopup: false });
    }

    showBatchCompletePopup() {
        this.setState({ showBatchCompletePopup: true });
    }

    changeUploadProgress() {
        this.setState({ percentage: 100 });
    }

    changeDropdownSelected(index, value){
        const dropdown_selected_copy = [...this.state.dropdown_selected];
        dropdown_selected_copy[index].value = value;
        this.setState({dropdown_selected: dropdown_selected_copy});
    }
    
    enableImport() {
        this.setState({ disableImport: false });  
    }

    disableImportAction() {
        this.setState({ disableImport: true });  
    }

    axiosRequest() {
        this.closePopup();
        const options = {
        };
        let searchRoute = config.contentService.routes.uploadMetadata;
        const url = urlHelper.formatUrl(
            config.contentService.baseUrl,
            searchRoute,
            {
                queryParams: {
                    "contentType": this.state.dropdown_selected[0].value,
                    "source": this.state.dropdown_selected[1].value,
                    "subType": this.state.dropdown_selected[2].value,
                    "unscrub": this.state.dropdown_selected[3].value
                },
            }
        );
        this.coverLinkTimeout = setInterval(() => {
            if (this.state.percentage < 90) {
                this.setState({ percentage: this.state.percentage + 5 });
            }
        }, 2000);
        AxiosClient.post(url, this.state.formData, { "headers": { "content-type": "multipart/form-data" }})
            .then(response => {
                this.changeUploadProgress();
                setTimeout(() => {
                    this.setState({ percentage: 0 });
                    if (this.coverLinkTimeout) {
                        clearInterval(this.coverLinkTimeout);
                    }
                    this.setState({ disableImport: true });
                    this.setState({ showBatchStatus: this.state.batchStatus });
                    this.setState({ showBatchCompletePopup: false });
                }, 500);
                this.setState({ batchId: response.data.batchId });
                this.setState({
                    batchStatus: TEXT_TYPES.SUCCESS_MSG,
                    statusModal: true
                });

            })
            .catch(error => {
                console.log("Error");
                if (error.response) {
                    this.changeUploadProgress();
                    setTimeout(() => this.setState({ percentage: 0 }), 500);
                    this.setState({ batchStatus: TEXT_TYPES.FAILED_MSG });
                    if(typeof error.response.data.message === 'object'){
                        this.setState({ failedMsg: " (" + (error.response.data.message)[Object.keys(error.response.data.message)[0]] + ")" });
                    }
                    else{
                        this.setState({ failedMsg: " (" + error.response.data.message + ")" });    
                    }
                }
                else {
                    this.setState({ batchStatus: TEXT_TYPES.FAILED_MSG });
                }
                if (this.coverLinkTimeout) {
                    clearInterval(this.coverLinkTimeout);
                }
                this.setState({ disableImport: true });
                this.setState({ showBatchStatus: this.state.batchStatus });
                return error;
            });
    }

    closeModal =()=>{
        this.setState({
            statusModal: false
        });
    };

    navigateToLogs = () => {
        this.setState({
            toViewLogs: true
        });
    };
    render() {
        if (this.state.toViewLogs) {
            return <Redirect to='/view-logs'/>;
        }
        return (
            <div className="upload-metadata-page">
                <div>
                    <label className="pe-page-title--small">{TEXT_TYPES.UPLOAD_METADATA}</label>
                    <hr />
                    <label className="hint1" >{TEXT_TYPES.SELECT_METADATA_NOTE}</label>
                    <MetadataUploadSelectComponent dropdown_selected={this.state.dropdown_selected} enableImport={this.state.enableImport} disableImportAction={this.state.disableImportAction} fileSelected={this.state.file}  changeDropdownSelected={this.changeDropdownSelected} />
                </div>
                {this.state.file != ""
                    && <FileUploadDisplayComponent file={this.state.file} percentage={this.state.percentage} showBatchStatus={this.state.showBatchStatus} failedMsg={this.state.failedMsg}/>
                }
                <ModalDialog
                    title={TEXT_TYPES.UPLOAD_METADATA_CONFIRMATION}
                    showModal={this.state.showPopup}
                    onCancel={this.closePopup.bind(this)}
                    onSuccess={this.axiosRequest.bind(this)}
                    successText="OK">
                    <div className="metadata-edit-dialog">
                        <p>
                            {TEXT_TYPES.UPLOAD_METADATA_CONFIRMATION_MSG.replace("$file", this.state.file)}
                        </p>
                    </div>
                </ModalDialog>

                <ModalDialog
                    title={TEXT_TYPES.UPLOAD_SUMMARY}
                    showModal={this.state.statusModal}
                    onCancel={this.closeModal}
                    onSuccess={this.navigateToLogs}
                    successText={"View Logs"}
                >
                    <p>{TEXT_TYPES.UPLOAD_METADATA_SUCCESS_MSG.replace("$file", this.state.file).replace("$batchId", this.state.batchId)}</p>
                </ModalDialog>
                <label className="pe-col-12 hint2" >{TEXT_TYPES.UPLOAD_METADATA_NOTE}</label>
                <div className="pe-col-12 fileLoad">
                    <div className="buttons">
                        <input type="file" id="fileLoader" name="files" title="Load File" onClick={(event) => { event.target.value = null; }} onChange={this.handleChange.bind(this)} />
                        <button type="file" name="files" className="pe-btn selectBtn " onClick={this.popupFileWindow.bind(this)}>Add Files</button>
                    </div>
                    <div className="buttons">                        
                        <button className="pe-btn pe-btn__primary" disabled={this.state.disableImport} onClick={this.showPopup}>Import</button>
                    </div>
                </div>
            </div >
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/ContentIngestion/UploadMetadataComponent.js